import { IconButton, Tooltip } from '@material-ui/core';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PropTypes from 'prop-types';
import React from 'react';
import { useActions, useValues } from 'kea';
import { maplogic, preferenceslogic } from 'src/store/global';
import History from './History';

const ActionButtons = ({ row }) => {
	const { vehicles } = useValues(maplogic);
	const { addOne, removeOne } = useActions(maplogic);


	const { vehicle } = useValues(preferenceslogic);
	const { setVehicle } = useActions(preferenceslogic);

	const { vehicles: vehiclesOnMap } = useValues(maplogic);

	const handle_focus = (existing_tracker) => {
		const pos = existing_tracker.status[0];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			global.gmap.setZoom(15);
		}
	}

	const includes_mobile_vehicles_on_map = (mobile_vehicle) => {
		let flag = vehicles.find((item) => {
			return item._id === mobile_vehicle._id;
		});
		if (flag === undefined) {
			return false;
		}
		return true;
	}

	const includes_vehiclesOnMap = (mobile_vehicle) => {
		let flag = vehiclesOnMap.find((item) => {
			return item._id === mobile_vehicle._id;
		});
		if (flag === undefined) {
			return false;
		}
		return true;
	}

	const handle_visible = (mobile_vehicle) => {
		if (includes_mobile_vehicles_on_map(mobile_vehicle)) {
			removeOne(mobile_vehicle);
		} else {
			handle_focus(mobile_vehicle.tracker);
			vehicles.forEach((item) => {
				// console.log(item);
				if (item.tracker && item.tracker.status.length > 0) {
					if (includes_vehiclesOnMap(item)) {
						removeOne(item);
					}
				}
			})
			setVehicle({ ...vehicle, expand: !vehicle.expand });
			addOne(mobile_vehicle);
		}
	}


	return (
		<div id={'rnd-ignore-drag'}>

			{
				row.tracker && row.tracker.status && row.tracker.status.length > 0
					?
					<>
						{
							includes_mobile_vehicles_on_map(row)
								?
								<>
									<IconButton
										onClick={() => {
											handle_visible(row);
										}}
										size='small'
									>
										<VisibilityOffIcon
										/>
										Hide
									</IconButton>
								</>
								:
								<>
									<IconButton onClick={() => {
										handle_visible(row);
									}}
										size='small'
									>
										<VisibilityIcon
										/>
										Show
									</IconButton>
								</>
						}
						<History vehicle={row} />
					</>
					:
					<>
						<IconButton disabled
							size='small'
						>
							<VisibilityIcon
							/> Show
						</IconButton>
					</>
				// <Button disabled variant="contained" color="primary" onClick={() => {
				// 	// edit(row);
				// 	console.log('focus clicked!');
				// }}>
				// 	No Tracker
				// </Button>
			}
		</div>

	);
};

ActionButtons.propTypes = {
	row: PropTypes.object.isRequired
};

export default ActionButtons;
